<template>
  <div class="left">
    <el-menu :default-active="currentIndex" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff"
      active-text-color="#ffd04b">
      <router-link :to="{name:'home'}" replace>
        <el-menu-item index="1">
          <i class="el-icon-tickets"></i>
          <span slot="title">数据分析</span>
        </el-menu-item>
      </router-link>
      <router-link :to="{name:'systemSetup'}" replace>
        <el-menu-item index="2">
          <i class="el-icon-setting"></i>
          <span slot="title">测试记录</span>
        </el-menu-item>
      </router-link>
    </el-menu>
  </div>
</template>

<script>
import api from '@/api/home'
export default {
  name: 'leftNav',
  data () {
    return {
      currentIndex: '1'
    }
  },
  created () {
    if (this.$route.name == 'home') {
      this.currentIndex = '1'
    } else {
      this.currentIndex = '2'
    };
  },
  methods: {

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../css/common.css";

.left {
  width: 100%;
  text-align: left;

  .el-menu-item {
    width: 200px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/nav/leftNav.vue